var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10019_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5166 16L49.0547 36.3198L54.1615 24.3447L76.5166 16Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5479 16.0239L37.8431 24.3462L42.6922 36.4784L15.5479 16.0239Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4652 59.2144L77.6028 59.4454L73.3609 73.8559L58.5503 69.778L65.4652 59.2144Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5345 59.2144L33.4239 69.7781L18.638 73.8562L14.4219 59.4454L26.5345 59.2144Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0326 33.3877L42.5288 49.4086L27.686 48.7333L31.9079 42.3639L31.9614 42.3025L42.0326 33.3877Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8136 33.2095L60.0385 42.3036L60.0914 42.3645L64.3134 48.7339L49.4741 49.409L49.8136 33.2095Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8587 59.2612L41.9633 65.5759L32.5488 70.1213L33.8587 59.2612Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1425 59.2598L59.4252 70.1209L50.0371 65.5751L58.1425 59.2598Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2446 64.9805L59.7714 69.5934L50.9096 73.8051L51.0016 71.0215L50.2446 64.9805Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7528 64.9824L41.0255 70.9758L41.0852 73.8017L32.2026 69.5933L41.7528 64.9824Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.002 51.4995L41.4915 56.7315L33.0156 54.2486L39.002 51.4995Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9977 51.5L59.0122 54.2484L50.5088 56.7307L52.9977 51.5Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5068 59.2075L33.1367 70.4674L25.7935 59.4537L34.5068 59.2075Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4941 59.2075L66.2077 59.4537L58.8369 70.4678L57.4941 59.2075Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5283 48.0967L58.1869 54.5594L53.2978 52.3252L50.9569 57.2462L49.4224 48.784L64.5283 48.0967Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4688 48.0967L42.5773 48.7841L41.0427 57.2463L38.7014 52.3259L33.838 54.5597L27.4688 48.0967Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0415 46.7705L34.2161 54.0507L34.4647 61.238L27.0415 46.7705Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9658 46.7573L57.5293 61.2506L57.8093 54.0506L64.9658 46.7573Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2265 47.2139L42.5153 49.0314L43.2288 53.5591L42.7701 67.4654L40.6013 56.2943L40.6006 56.1788L42.2265 47.2139Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7693 47.189L51.3995 56.179L51.3988 56.2945L49.2246 67.4935L49.1386 64.6924L48.7993 53.4769L49.7693 47.189Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4473 53.7617L58.2044 60.0062L50.636 65.903L49.106 64.822L50.821 55.9881L58.4473 53.7617Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5791 53.7617L41.179 55.9882L42.894 64.8219L41.364 65.9029L33.7951 60.0056L33.5791 53.7617Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7544 68.2144L40.4374 72.8023L40.3964 70.8432L41.2066 70.132H50.79L51.6296 70.8408L51.5677 72.7986L61.1893 68.226L56.5074 72.0948L50.846 75.9833H41.129L35.4713 72.0789L30.7544 68.2144Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5507 64.3696L50.9198 65.3367L51.7221 71.7379L50.561 70.7575H41.4422L40.3032 71.7576L41.0792 65.3372L42.4487 64.3696H49.5507Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7034 16.5625L77.9998 26.4519L75.9412 36.451L77.4071 37.5819L75.4234 39.0954L76.9142 40.2467L74.9401 42.0446L76.1521 42.9223L72.9357 46.6788L59.7432 42.8376L59.6288 42.7764L50.1221 34.7567L74.7034 16.5625Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2965 16.5625L41.8779 34.7567L32.3711 42.7764L32.2568 42.8376L19.0642 46.6788L15.8478 42.9223L17.0588 42.0452L15.0856 40.2467L16.5736 39.0966L14.5603 37.5788L16.0816 36.4472L14 26.4522L17.2965 16.5625Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0979 41.9976L73.0762 46.0673L77.6175 60.0636L65.6366 60.0636L57.3813 60.1678L63.3849 48.4658L59.0979 41.9976Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9021 41.9976L28.6143 48.4658L34.6186 60.1678L26.3674 60.0636H14.4077L18.9236 46.0674L32.9021 41.9976Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.846 24.2778L50.9362 34.8375L50.1065 49.1027L49.789 53.5739L49.7638 64.9958H42.236L42.2116 53.5953L41.8931 49.0988L41.063 34.8375L37.1538 24.2778H54.846Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10019_6426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 60,
    fill: "white",
    transform: "translate(14 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/Metamask.b490300dffebc017fe59d212ca35a7ff.svg";
export { ForwardRef as ReactComponent };